var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('svg',{staticClass:"completed-header-icon",attrs:{"viewBox":"0 0 100 100"}},[_c('circle',{staticClass:"circle",attrs:{"cx":"50","cy":"50","r":"50"}}),_c('path',{staticClass:"checkmark",attrs:{"d":"M 28 50 l 15 15 l 33 -33"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }